import {
  isValidElement,
  type ComponentType,
  type ReactElement,
  type ReactNode,
} from 'react';

export type WorkbenchIconCandidate =
  | ReactNode
  | ComponentType<{ className?: string }>
  | null
  | undefined;

function isWorkbenchIconComponent(
  icon: WorkbenchIconCandidate,
): icon is ComponentType<{ className?: string }> {
  if (typeof icon === 'function') return true;
  return typeof icon === 'object' && icon !== null && !isValidElement(icon) && '$$typeof' in icon;
}

export function renderWorkbenchIcon(icon: WorkbenchIconCandidate, className: string) {
  if (!icon) return null;
  if (isValidElement(icon)) return icon as ReactElement;
  if (isWorkbenchIconComponent(icon)) {
    const Icon = icon as ComponentType<{ className?: string }>;
    return <Icon className={className} />;
  }
  return icon;
}

export function getWorkbenchIconComponent(icon: WorkbenchIconCandidate) {
  if (!icon || !isWorkbenchIconComponent(icon)) return null;
  return icon;
}
